/**
 * Subscription service
 */
import api from './api';

export const subscriptionService = {
  /**
   * Get user's subscriptions
   */
  async getSubscriptions() {
    console.log('[SubscriptionService] Fetching user subscriptions...');
    try {
      const response = await api.get('/api/subscriptions/my');
      console.log('[SubscriptionService] Subscriptions response:', response.data);
      console.log('[SubscriptionService] Number of subscriptions:', response.data?.length || 0);
      return response.data;
    } catch (error) {
      console.error('[SubscriptionService] Error fetching subscriptions:', error);
      console.error('[SubscriptionService] Error response:', error.response?.data);
      throw error;
    }
  },

  /**
   * Get user's subscriptions (alias for backward compatibility)
   */
  async getMySubscriptions() {
    return this.getSubscriptions();
  },

  /**
   * Get creator's subscribers
   */
  async getMySubscribers() {
    const response = await api.get('/api/subscriptions/subscribers');
    return response.data;
  },

  /**
   * Subscribe to creator
   */
  async subscribe(creatorId, tier = 'free') {
    const response = await api.post('/api/subscriptions/create', {
      creator_id: creatorId,
      tier
    });
    return response.data;
  },

  /**
   * Check subscription status
   */
  async checkSubscription(creatorId) {
    const response = await api.get(`/api/subscriptions/status/${creatorId}`);
    return response.data;
  },

  /**
   * Cancel subscription
   */
  async cancelSubscription(subscriptionId) {
    const response = await api.delete(`/api/subscriptions/${subscriptionId}`);
    return response.data;
  },

  /**
   * Unsubscribe (alias for cancelSubscription)
   */
  async unsubscribe(subscriptionId) {
    return this.cancelSubscription(subscriptionId);
  }
};
